module.exports = __webpack_public_path__ + "static/media/delivery.973a9d33.svg";